import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { ISlateTextElement } from "@faire/web-api/indigofair/data/ISlateTextElement";
import { Span } from "@faire/web/slate/Typography";
import React from "react";

interface IProps {
  textElement: ISlateTextElement | undefined;
}

export const SlateText: React.FC<IProps> = ({ textElement }) => {
  if (!textElement?.text) {
    return null;
  }

  const variant = getSlateTypographyVariant(
    textElement?.style?.type,
    textElement?.style?.decorators
  );

  return <Span variant={variant}>{textElement.text}</Span>;
};
